import * as dom from '../util/dom';
import * as statsUtil from '../util/stats';


const NAMESPACE = 'akamaiStats.';
const instances = new Map();
const initialized = new Map();
const currentStream = new Map();

function loadLibs() {
    window.AKAMAI_MEDIA_ANALYTICS_CONFIG_FILE_PATH = 'https://ma291-r.analytics.edgekey.net/config/beacon-8803.xml?enableGenericAPI=1';

    return dom.getScript('https://79423.analytics.edgekey.net/js/csma.js');
}

class AkaHTML5AnalyticsGetters {
    constructor(api) {
        this.api = api;
    }

    // Below is used by statistics lib

    // noinspection JSUnusedGlobalSymbols
    streamHeadPosition() {
        return this.api.getCurrentTime();
    }

    // noinspection JSUnusedGlobalSymbols
    streamLength() {
        return this.api.getDuration();
    }

    // noinspection JSUnusedGlobalSymbols
    streamURL() {
        return this.api.getSrc();
    }
}

function handlePlaying(api, analytics) {
    if (!initialized.get(api)) {
        analytics.handleSessionInit();
        initialized.set(api, true);
    } else if (api.getSrc() !== currentStream.get(api)) {
        analytics.handleStreamSwitch();
    }
    currentStream.set(api, api.getSrc());

    analytics.handlePlaying();
}

function handleMetadata(analytics, metaData) {
    const client = statsUtil.getClient();
    analytics.setData('device', navigator.platform);
    analytics.setData('playerId', 'svtvideoplayer-html5-' + client);

    if (metaData.mmsStatistics) {
        const show = metaData.mmsStatistics.ns_st_pr;
        const title = show + ' - ' + metaData.mmsStatistics.ns_st_ep + ' (' + metaData.programVersionId + ')';

        analytics.setData('title', title);
        analytics.setData('show', show);
        analytics.setData('eventName', title);
    }
}

export function create(api) {
    if (instances.has(api)) {
        Debug.warn(
            `Akamai statistics plugin was already created for this api instance and has
            not been destroyed. The previous instance may leak memory and listeners.`
        );
    }

    loadLibs()
        .then(() => {
            const analytics = new window.AkaHTML5MediaAnalytics(new AkaHTML5AnalyticsGetters(api));
            analytics.setData('viewerId', 'unknown viewer');
            // TODO: Only do below for SVT CDN
            analytics.disableServerIpLookUp();

            api.on(NAMESPACE + 'playing', () => handlePlaying(api, analytics));
            api.on(NAMESPACE + 'pause', () => analytics.handlePause());
            api.on(NAMESPACE + 'resume', () => analytics.handleResume());
            api.on(NAMESPACE + 'bufferEmpty', () => {
                if (api.video().seeking === false) {
                    analytics.handleBufferStart();
                }
            });
            api.on(NAMESPACE + 'bitrateswitch', (event) => analytics.handleBitRateSwitch(event.detail.bitrate));
            api.on(NAMESPACE + 'ended', () => analytics.handlePlayEnd('Play.End.Detected'));
            api.on(NAMESPACE + 'error', (err) => analytics.handleError(err && err.name ? err.name : 'Unknown error'));

            api.on(NAMESPACE + 'metadata', (data) => handleMetadata(analytics, data.detail));

            instances.set(api, analytics);
        });
}

export function destroy(api) {
    const analytics = instances.get(api);

    if (analytics) {
        api.off(NAMESPACE + 'playing');
        api.off(NAMESPACE + 'pause');
        api.off(NAMESPACE + 'resume');
        api.off(NAMESPACE + 'waiting');
        api.off(NAMESPACE + 'bitrateswitch');
        api.off(NAMESPACE + 'ended');
        api.off(NAMESPACE + 'error');

        api.off(NAMESPACE + 'metadata');

        analytics.handleApplicationExit();

        instances.delete(api);
    }
}



// WEBPACK FOOTER //
// ./src/js/plugins/akamai-stats.js